export default "https://cdn-gra-staging.amplement.io/statics/images/browsers/firefox.png";